import { Navigate } from "react-router-dom";

// Authentication related pages
import ForgetPwd from "../pages/Authentication/ForgetPassword";
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";

// Dashboard
import Dashboard from "../pages/Dashboard/index";

//Utility
import Error404 from "../pages/Utility/Error404";
import Maintenance from "../pages/Utility/Maintenance";

// Forms
import FormAdvanced from "../pages/Forms/FormAdvanced";
import FormEditors from "../pages/Forms/FormEditors";
import FormElements from "../pages/Forms/FormElements";
import FormMask from "../pages/Forms/FormMask";
import FormUpload from "../pages/Forms/FormUpload";
import FormWizard from "../pages/Forms/FormWizard";
import FormXeditable from "../pages/Forms/FormXeditable";

//Ui

// import Profile from "../pages/User/Profile";
import ResetPassword from "../pages/Authentication/ResetPassword";
import Notification from "../pages/Notification";
import NotificationDetails from "../pages/Notification/NotificationDetails";
import Settings from "../pages/Settings";
import General from "../pages/Settings/General";
import AddRoleAndPermission from "../pages/Settings/Role And Permissions/AddRole";
import RolesAndPermissions from "../pages/Settings/Role And Permissions/RolesAndPermissions";
import User from "../pages/Settings/User/User";
import UserDetails from "../pages/Settings/User/UserDetails";
import UserProfile from "../pages/UserProfile/UserProfile";
import NotAuthorized from "../pages/Utility/NotAuthorized";
import Advert from "../pages/Advert";
import AdvertDetails from "../pages/Advert/AdvertDetails";
import CreateSupport from "../pages/Support/CreateSupport";
import Register from "../pages/Register";
import AddAdvert from "../pages/Advert/AddAdvert";
import Accessories from "../pages/Accessories";
import Credit from "../pages/Credit";
import Inquiries from "../pages/Inquiries";
import LoanCalculator from "../pages/LoanCalculator";
import EditAdvert from "../pages/Advert/EditAdvert";
import AddAccessory from "../pages/Accessories/AddAccessory";
import EditAccessory from "../pages/Accessories/EditAccessory";
import AccessoryDetails from "../pages/Accessories/AccessoryDetails";
import AcceptInvitation from "../pages/AcceptInvitation";
import RedirectPage from "../pages/Authentication/RedirectPage";
//need requiredPermission for permission access 

const authProtectedRoutes = [
	//dahsboard
	{ path: "/dashboard", component: <Dashboard />, },
	//user
	{ path: "/profile", component: <UserProfile title={"Profile"} /> },

	//notification
	{ path: "/notification", component: <Notification title={"Notification"} /> },
	{ path: "/notification/:ID", component: <NotificationDetails title={"View Notification"} />, },

	//advert
	{ path: "/advert", component: <Advert title={"Advert"} /> },
	{ path: "/advert/:ID", component: <AdvertDetails title={"View Advert"} />, },
	{ path: "/add-advert", component: <AddAdvert title={"Add Advert"} />, },
	{ path: "/edit-advert/:ID", component: <EditAdvert title={"Edit Advert"} />, },

	//accessories
	{ path: "/accessories", component: <Accessories title={"Accessories"} /> },
	{ path: "/accessories/:ID", component: <AccessoryDetails title={"View Accessory"} />, },
	{ path: "/add-accessory", component: <AddAccessory title={"Add Accessory"} /> },
	{ path: "/edit-accessory/:ID", component: <EditAccessory title={"Edit Accessory"} /> },

	//credits
	{ path: "/credits", component: <Credit title={"Credits"} /> },

	//inquiries
	{ path: "/inquiries", component: <Inquiries title={"Inquiries"} /> },

	//loan-calculator
	{ path: "/loan-calculator", component: <LoanCalculator title={"Loan Calculator"} /> },

	//support
	{ path: "/support", component: <CreateSupport title={"Support"} /> },

	// Setting
	{ path: "/settings", component: <Settings />, requiredPermission: ["view-setting"], },
	{ path: "/settings-general", component: <General />, requiredPermission: ["view-setting"], },
	// users
	{ path: "/settings-users", component: <User />, requiredPermission: "view-setting" },
	{ path: "/settings-users/:type/:ID", component: <UserDetails title={"Users"} />, requiredPermission: "view-setting" },
	// { path: "/add-user", component: <AddCustomers type="Add" title="Create New User" />, requiredPermission: "create-setting" },
	// { path: "/edit-user/:ID", component: <AddCustomers type="Edit" title="Edit User" />, requiredPermission: "update-setting" },
	//roles
	{ path: "/settings-roles", component: <RolesAndPermissions />, },
	{ path: "/add-settings-roles", component: <AddRoleAndPermission type="Add" title="Create New Role" />, },
	{ path: "/edit-settings-roles/:ID", component: <AddRoleAndPermission type="Edit" title="Edit Role" />, requiredPermission: "update-role" },

	// Forms
	{ path: "/form-elements", component: <FormElements /> },
	{ path: "/form-advanced", component: <FormAdvanced /> },
	{ path: "/form-editors", component: <FormEditors /> },
	{ path: "/form-mask", component: <FormMask /> },
	{ path: "/form-file-upload", component: <FormUpload multiple={true} images={false} />, },
	{ path: "/form-wizard", component: <FormWizard /> },
	{ path: "/form-xeditable", component: <FormXeditable /> },

	// this route should be at the end of all other routes
	{ path: "/", exact: true, component: <Navigate to="/dashboard" /> },
];

const publicRoutes = [
	{ path: "/logout", component: <Logout /> },
	{ path: "/login", component: <Login /> },
	{ path: "/forgot-password", component: <ForgetPwd /> },
	{ path: "/reset-password", component: <ResetPassword /> },
	{ path: "/login/:token", component: <RedirectPage /> },
	{ path: "/register", component: <Register /> },
	{ path: "/accept-invitation", component: <AcceptInvitation /> },

	{ path: "/maintenance", component: <Maintenance /> },
	{ path: "/404", component: <Error404 /> },
	{ path: "/not-authorized", component: <NotAuthorized /> },
];

export { authProtectedRoutes, publicRoutes };

